/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";

export const customTokenRefreshRequestSchema = z.object({
	refresh: z.string().min(1),
});
